<template>
<div>
    <v-text-field
        :label="label"
        hint="You can separate multiple email addresses using a semi-colon (;)"
        :value="text_field_value"
        v-on:input="onChange"
    />

    <v-chip
        v-for="(item, index) in value"
        :key="index"
        style="margin-right: 5px"
        close
        v-on:click:close="onRemove(index)"
    >
        {{item}}
    </v-chip>
</div>
</template>

<script>
const _ = require('lodash');
export default {

    props: {
        label: {
            type: String,
            default: function() { return 'Email Address(es)'},
        },

        value: {
            type: Array,
            default: function() { return []; }
        },
    },

    methods: {
        onChange(new_value) {
            new_value = new_value.replaceAll(',',';');

            let parts = new_value.split(';');
            let ret = [];

            for ( let i = 0; i < parts.length; i++ )
            {
                let cv = parts[i].trim();
                if ( cv.length == 0 ) continue;

                ret.push(cv);
            }

            this.$emit('input',ret);
        },

        onRemove(index)
        {
            let ret = _.cloneDeep(this.value);
            ret.splice(index,1);
            this.$emit('input',ret);
        },
    },

    computed: {
        text_field_value() {
            return this.$rc.pretty(this.value, 'semi_list');
        }
    },
}
</script>

<style lang="scss" scoped>

</style>